<!--课程资源-->
<!--2.4版本修改为 训练（测评）资源-->
<template>
  <div id="CourseResource">
    <transition>
      <div v-if="!editCoursePackage">
        <div class="search">
          <a-form-model layout="inline" :model="searchForm">
            <a-form-model-item :label="textTit + '资源'">
              <a-input :maxLength="30" v-model="searchForm.courseName" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item label="适用学段">
              <a-select class="serach-item" allowClear :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model="searchForm.period" placeholder="请选择学段">
                <a-select-option :value="item" v-for="item in $data._period">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-right: 35px">
              <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询</a-button>
              <a-button @click="searchReset" style="margin-left: 10px"> 重置</a-button>
            </a-form-model-item>
            <a-form-model-item v-if="textTit == '训练'">
              <a-button :loading="addCourseResource.dataLoading" @click="addResource()" icon="plus" type="primary">
                添加{{ textTit }}资源
              </a-button>
            </a-form-model-item>
            <a-form-model-item v-else-if="textTit == '活动'">
              <a-button :loading="addCourseResource.dataLoading" @click="addResource()" icon="plus" type="primary">
                添加{{ textTit }}资源
              </a-button>
            </a-form-model-item>
            <a-form-model-item v-else>
              <a-button :loading="addCourseResource.dataLoading" @click="addResource()" icon="plus" type="primary">
                添加{{ textTit }}资源
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div style="overflow: auto; margin-top: 15px">
          <a-spin :spinning="tableRelevant.tableLoading">
            <div v-if="tableRelevant.tableDataSource.length <= 0" class="ant-table-content">
              <div class="ant-table-placeholder">暂无数据</div>
            </div>
            <div class="list">
              <template v-for="item in tableRelevant.tableDataSource">
                <CoursePackage class="item" v-if="item.resourceType == 1" :key="item.id" :course="item"
                               @native="editCoursePackage = item" @edit="editPackage" @remove="removePackage" />
                <RourceItem
                  v-else
                  :type="2"
                  class="item"
                  @edit="edit(item)"
                  :detail="item"
                  @del="delCourseResource(item)"
                  @click.native="goCourseHourResource(item)"
                  :roundCount="$route.query.tabActive == 1"
                ></RourceItem>
              </template>
            </div>
            <div v-if="tableRelevant.tablePagination.total > 0" style="width: 100%; overflow: hidden">
              <a-pagination
                :showTotal="tableRelevant.tablePagination.showTotal"
                :total="tableRelevant.tablePagination.total"
                :pageSize="tableRelevant.tablePagination.pageSize"
                :page-size-options="['10', '20', '30']"
                show-size-changer
                show-quick-jumper
                :current="tableRelevant.tablePagination.current"
                @change="tableRelevant.tablePagination.onChange"
                @showSizeChange="tableRelevant.tablePagination.onShowSizeChange"
                style="float: right"
              />
            </div>
          </a-spin>
        </div>
      </div>

      <CoursePackageList v-else :course-package="editCoursePackage"
                         @back="editCoursePackage = null"></CoursePackageList>
    </transition>
    <!--添加课程资源-->
    <a-modal
      v-model="addCourseResource.visible"
      :centered="true"
      :destroyOnClose="true"
      :confirm-loading="addCourseResource.confirmLoading"
      :title="`${handleType == 'edit' ? '编辑' + textTit : '设置' + textTit}资源`"
      @cancel="handleCancel"
      width="1300px"
    >
      <div slot="footer">
        <a-button @click="addCourseResourceCancel()">{{ handleType == "edit" ? "取消" : "上一步" }}</a-button>
        <a-button @click="addCourseResourceOk" type="primary">确定</a-button>
      </div>
      <div class="addCourseResource">
        <div v-if="handleType != 'edit'" class="pack-resource">
          <span class="pack-label">打包课程：</span>
          <a-switch v-model="packResource" @change="onChangePack" />
          <a-tooltip placement="top">
            <div class="pack-tooltip" slot="title">
              开启后，课程资源将按照资源包形式展示
              <!-- </br> -->
              方便统一扣点，不影响机构配课
            </div>
            <a-icon class="pack-icon" size="18" type="info-circle" />
          </a-tooltip>
        </div>
        <div class="head-form" v-if="addCourseResourceDetailList.length > 1 && !packResource">
          <div class="title">批量设置：</div>
          <a-form :form="addCourseResForm.form" layout="inline" @submit="addCourseResFormSubmit">
            <a-form-item label="可用人次">
              <a-input-number :min="1" :disabled="addCourseResForm.isLimitCount" :precision="0" placeholder="请输入"
                              :max="9999" v-model="addCourseResForm.maxCount" />
              <a-checkbox v-model="addCourseResForm.isLimitCount" @change="addCourseResFormCheck('maxCount')"> 不限制
              </a-checkbox>
            </a-form-item>
            <a-form-item v-if="$route.query.tabActive == 1" label="课时数">
              <a-input-number :min="0" v-model="addCourseResForm.childCourseCount" :precision="0"
                              placeholder="请输入整数" :max="9999" />
              <a-checkbox v-model="addCourseResForm.allCourse" @change="addCourseResFormCheck('childCourseCount')">
                全部
              </a-checkbox>
            </a-form-item>
            <!-- <a-form-item v-if="$route.query.tabActive == 1" label="报告生成频率">
             每
             <a-input-number :min="1" :precision="0" placeholder="请输入" :max="9999" v-model="addCourseResForm.reportFrequency" />
             课时生成一次报告
           </a-form-item> -->
            <a-form-item>
              <a-button type="primary" html-type="submit"> 一键设置</a-button>
            </a-form-item>
          </a-form>
        </div>
        <PackResource v-if="packResource" ref="PackResourceRef" :textTit="textTit"
                      :courseType="{ 测评: 1, 训练: 2, 活动: 3 }[textTit]" :courseList="coursePackList"></PackResource>
        <div v-else class="content">
          <a-card v-for="(item, index) in addCourseResourceDetailList" :key="item.id"
                  style="width: 100%; margin-top: 20px">
            <div slot="title">
              {{ (item.name || item.courseName) + (item.period ? ` - ${item.period}` : "") }}
              <span v-if="item.repeatErrMsg" style="color: red; font-size: 12px; margin-left: 6px">{{ item.repeatErrMsg
                }}</span>
            </div>
            <a-popconfirm v-if="!item.id" slot="extra" title="确认要删除此课程吗？"
                          @confirm="delCourseResource(item, index)">
              <a-button icon="delete" type="link">删除</a-button>
            </a-popconfirm>
            <a-form-model class="form" style="position: relative">
              <a-form-model-item label="可用人次" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }" class="userCount">
                <div>
                  <div>
                    <a-input-number
                      :disabled="item.isLimitCount"
                      :min="item.usedCount || 1"
                      :precision="0"
                      :max="9999"
                      v-model="item.maxCount"
                      :style="item.error ? { borderColor: 'red' } : {}"
                      placeholder="请输入可用人次"
                      @change="clearError(item, 'maxCount')"
                      style="width: 140px"
                    />
                    <a-checkbox @change="clearError(item, 'maxCount')" v-model="item.isLimitCount"
                                style="margin-left: 20px"> 不限制
                    </a-checkbox>
                  </div>
                  <span v-if="item.boolerrMsg" class="err-msg">{{ item.boolerrMsg }}</span>
                </div>
              </a-form-model-item>
              <a-form-model-item v-if="$route.query.tabActive == 1" label="课时数" :labelCol="{ span: 5 }"
                                 :wrapperCol="{ span: 18 }" class="userCount">
                <div class="coutom-form-item">
                  <div>
                    <a-input-number
                      :min="0"
                      :precision="0"
                      :max="999"
                      v-model="item.childCourseCount"
                      :style="item.courseError ? { borderColor: 'red' } : {}"
                      placeholder="请输入整数"
                      style="width: 140px"
                      :disabled="handleType === 'edit'"
                      @change="changeChild(item)"
                    />
                    <a-checkbox :disabled="handleType === 'edit'" v-model="item.allCourse"
                                @change="(e) => changeCourseNumber(e.target.checked, item)" style="margin-left: 20px"
                    >{{ item.course?.courseChildCount }}节
                    </a-checkbox>
                  </div>
                  <span v-if="item.errMsg" class="err-msg">{{ item.errMsg }}</span>
                </div>
              </a-form-model-item>
              <!-- <template v-if="$route.query.tabActive == 1">
                <a-form-model-item style="margin-left: -6px" label="报告生成频率" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
                  每
                  <a-input-number :disabled="handleType == 'edit'" v-model="item.reportFrequency" style="width: 140px;" :min="1" :precision="0" :max="9999"  :placeholder="item.reportFrequenc ? '请输入整数' : ''"></a-input-number>
                  课时生成一次报告
                </a-form-model-item>
              </template> -->
              <a-form-model-item v-if="item.reportList.length"
                                 style="margin-left: -6px" label="课程报告"
                                 :labelCol="{ span: 5 }"
                                 :wrapperCol="{ span: 19 }">
                <a-select @change="e => selectReportChange(e, item)"
                          v-model="item.reportChecked" mode="multiple" placeholder="请选择" style="width: 300px">
                  <a-select-option v-for="report in item.reportList" :value="report.id" :disabled="report.disabled" :key="report.id">
                    {{ report.reportName }} {{ report.reportFrequency ? `- ${report.reportFrequency}` : "" }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </a-card>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="selectCourse.visible" width="1200px" class="add-resource" :confirm-loading="selectCourse.loading"
             :centered="true" title="选择课程" @cancel="selectCancel" @ok="selectCourseOk">
      <keep-alive :key="cacheKey">
        <addCourseResource :key="cacheKey" ref="addCourseResourceTable" :type="textTit" :includes="selectIncludes" />
      </keep-alive>
    </a-modal>
    <!-- 记录 -->
    <a-modal v-model="useRrcord.visible" :centered="true" :destroyOnClose="true" :footer="null" title="使用记录"
             width="1100px">
      <a-form-model layout="inline" :model="useRrcord.form">
        <a-form-model-item label="账期范围">
          <!-- <a-range-picker v-model="useRrcord.form.date" valueFormat="YYYY-MM-DD" @change="changeDate"/> -->
          <a-month-picker v-model="useRrcord.form.startTime" :disabled-date="disabledStartDate" format="YYYY-MM"
                          placeholder="开始时间" @openChange="handleStartOpenChange" />
          <a-month-picker
            style="margin-left: 10px"
            :disabled-date="disabledEndDate"
            placeholder="结束时间"
            :open="endOpen"
            format="YYYY-MM"
            v-model="useRrcord.form.endTime"
            @openChange="handleEndOpenChange"
          />
        </a-form-model-item>
        <a-form-model-item style="margin-left: 30px">
          <a-button @click="getRecordList(1)" type="primary" html-type="button"> 查询</a-button>
          <a-button style="margin-left: 10px" @click="downLoad">导出</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="table" style="margin-top: 15px">
        <a-table
          style="min-width: 800px"
          :columns="columns"
          row-key="id"
          :pagination="useRrcord.tableRelevant.tablePagination"
          :loading="useRrcord.tableRelevant.tableLoading"
          :locale="useRrcord.tableRelevant.locale"
          :dataSource="useRrcord.tableRelevant.tableDataSource"
        >
        </a-table>
      </div>
    </a-modal>
    <EditPackResourceModal ref="EditPackResourceModalRef" :textTit="textTit" />
  </div>
</template>

<script>
import xlsx from "xlsx";
import { tableRelevant } from "@/pages/projectImpl/js/utils";
import addCourseResource from "@/pages/projectImpl/orgManage/components/AddCourseResource.vue";
import RourceItem from "@/components/RourceItem";
import PackResource from "../components/packResource.vue";
import CoursePackage from "../components/CoursePackage.vue";
import CoursePackageList from "./coursePackageList.vue";
import EditPackResourceModal from "../components/editPackResourceModal.vue";

const columns = [
  { title: "账期", key: "1", dataIndex: "yearMonth" },
  { title: "消耗人次", key: "2", dataIndex: "consumeCount" },
  { title: "累计消耗", key: "3", dataIndex: "totalConsumeCount" },
];

export default {
  name: "CourseResource",
  components: {
    addCourseResource,
    EditPackResourceModal,
    CoursePackageList,
    PackResource,
    CoursePackage,
    RourceItem,
  },
  props: ["isEvaluation", "isActivity"],
  data() {
    return {
      cacheKey: 1,
      selectIncludes: [],
      editCoursePackage: null,
      organizationId: this.$route.query.id,
      searchForm: {
        courseName: undefined,
        period: undefined,
      },
      tableRelevant: tableRelevant.call(this),
      addCourseResource: {
        visible: false,
        dataLoading: false,
        confirmLoading: false,
      },
      selectCourse: {
        visible: false,
        loading: false,
      },
      addCourseResourceDetailList: [],
      addCourseResForm: {
        form: this.$form.createForm(this, { name: "addCourseResForm" }),
        isLimitCount: false,
        isLimitUsageTimes: false,
        usageTimes: 1,
        reportFrequency: undefined,
      },
      textTit: "训练",
      handleType: "add",
      reportList: [],
      columns,
      packResource: false,
      useRrcord: {
        visible: false,
        record: {},
        form: {
          date: undefined,
          startTime: undefined,
          endTime: undefined,
        },
        tableRelevant: tableRelevant.call(this),
      },
      endOpen: false,
    };
  },
  watch: {
    "useRrcord.visible"(val) {
      if (!val) {
        this.useRrcord.form.date = undefined;
        this.useRrcord.form.startTime = undefined;
        this.useRrcord.form.endTime = undefined;
      }
    },
    "$route.query.tabActive"() {
      this.editCoursePackage = null;
    },
  },
  computed: {
    coursePackList() {
      return this.addCourseResourceDetailList.map((v) => ((v._courseId = v.id), v));
    },
  },
  created() {
    if (this.$route.query.tabActive == 1) {
      this.textTit = "训练";
    } else if (this.$route.query.tabActive == 2) {
      this.textTit = "活动";
    } else {
      this.textTit = "测评";
    }
  },
  mounted() {
    this.tableRelevant.tablePagination.pageSize = 10;
    this.getPageList();
  },
  methods: {
    selectReportChange(values, resource) {
      const frequencys = resource.reportList.filter(f => f.frequency && values.includes(f.id)).map(m => m.frequency);
      resource.reportList = resource.reportList.map(m => {
        m.disabled = frequencys.includes(m.frequency) && !values.includes(m.id);
        return m;
      });
    },
    handleCancel() {
      this.addCourseResource.visible = false;
      this.addCourseResourceCancel(true);
      this.selectCancel();
    },
    selectCancel() {
      this.cacheKey = +new Date();
      this.selectIncludes = [];
    },
    async removePackage(record) {
      this.$confirm({
        title: `确认要删除此${["", "测评", "训练", "活动"][record.courseType]}资源包？`,
        content: "资源删除后所有相关数据都将删除且不可恢复，请谨慎操作",
        okType: "danger",
        centered: true,
        onOk: () => {
          this.$http.CourseService.delCoursePackage(record.id).then(() => {
            this.$message.success("删除成功");
            this.getPageList(1);
          });
        },
      });
    },
    async editPackage(record) {
      const options = {
        organizationId: this.organizationId,
        textTit: this.textTit,
        ...record,
      };
      await this.$refs["EditPackResourceModalRef"].showModal(options);
      this.getPageList(1);
    },
    onChangePack(e) {
    },
    changeChild(item) {
      if (item.childCourseCount !== item.course.courseChildCount) {
        item.allCourse = false;
      }
      this.clearError(item, "childCourseCount");
    },
    async checkCourseResource(arr) {
      const params = {
        organizationId: this.organizationId,
        source: this.handleType == "edit" ? arr[0].source || 0 : 0,
        addCourseList: arr.map(m => ({
          "courseId": m.courseId,
          "childCourseCount": m.childCourseCount,
        })),
      };
      const data = await this.$http.Course.checkCourseResource(params).catch(err => err);
      if (data.isSuccess) {
        return true;
      }
      const errorList = data.data;
      if (errorList && errorList.length) {
        this.$message.error("相同课时数课程已存在");
        this.addCourseResourceDetailList.forEach((v) => {
          if (errorList.includes(v.id)) {
            v.repeatError = true;
            v.repeatErrMsg = "相同课时数课程已存在";
            this.$set(v, "repeatErrMsg", "相同课时数课程已存在");
          }
        });
        return false;
      }
      return true;
    },
    changeCourseNumber(e, item) {
      if (e) {
        item.childCourseCount = item.course?.courseChildCount || 0;
      } else {
        item.childCourseCount = undefined;
      }
      this.$set(item, "allCourse", e);
      this.clearError(item, "childCourseCount");
    },
    materialEnabled(item) {
      let formData = new FormData();
      formData.append("organizationCourseResourceId", item.id);
      formData.append("status", item.organizationCourseMaterialEnabled);
      this.$http.resourcesList.materialConfigStatus(formData).then((res) => {
        this.$message.destroy();
          this.$message.success("修改成功");
          // item.organizationCourseMaterialEnabled = !item.organizationCourseMaterialEnabled
      });
    },
    //教学资源配置
    setting(item) {
      let baseUrl = "";
      if (process.env.VUE_APP_ENVIRONMENT === "preview") {
        // 正式
        baseUrl = "https://admin.iquizoo.com/";
      } else if (process.env.VUE_APP_ENVIRONMENT === "uat") {
        // 预发布
        baseUrl = "http://admin.uat.iquizoo.com/";
      } else {
        // 测试
        baseUrl = "http://admin.alpha.iquizoo.com/";
        // baseUrl = 'http://localhost:8080/'
      }
      const Url = baseUrl + "projectImpl/pTeachResources?id=" + item.id + "&courseId=" + item.courseId;
      window.open(Url);
    },

    // 中国标准时间 转换成 年月日
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      return y + "-" + m;
    },
    disabledStartDate(startValue) {
      const endValue = this.useRrcord.form.endTime;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.useRrcord.form.startTime;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    record(text) {
      this.useRrcord.visible = true;
      this.useRrcord.record = text;
      this.getRecordList(1);
    },
    getRecordList(pageIndex) {
      if (this.useRrcord.form.startTime != null) {
        this.useRrcord.form.startTime = typeof this.useRrcord.form.startTime == "object" ? this.getSimpleDate(this.useRrcord.form.startTime._d) : this.useRrcord.form.startTime;
      }
      if (this.useRrcord.form.endTime != null) {
        this.useRrcord.form.endTime = typeof this.useRrcord.form.endTime == "object" ? this.getSimpleDate(this.useRrcord.form.endTime._d) : this.useRrcord.form.endTime;
      }
      let params = {
        courseResourceId: this.useRrcord.record.id,
        startTime: this.useRrcord.form.startTime,
        endTime: this.useRrcord.form.endTime,
        pageIndex: pageIndex || this.useRrcord.tableRelevant.tablePagination.current,
        pageSize: this.useRrcord.tableRelevant.tablePagination.pageSize,
      };
      this.useRrcord.tableRelevant.tableLoading = true;
      this.$http.Course.getUsageRecord(params)
        .then((res) => {
          const { data } = res;
          this.useRrcord.tableRelevant.tableDataSource = data.items;
        }).finally(() => {
        this.useRrcord.tableRelevant.tableLoading = false;
      })
    },
    // 导出
    downLoad() {
      let excelTitle = this.useRrcord.record.courseName + "使用记录";
      const arr = [columns.map((m) => m.title)];
      this.useRrcord.tableRelevant.tableDataSource.forEach((f) => {
        arr.push([f.yearMonth, f.consumeCount, f.totalConsumeCount]);
      });
      const aoa = xlsx.utils.aoa_to_sheet(arr);
      const book = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(book, aoa, "第一页");
      xlsx.writeFile(book, excelTitle + ".xlsx");
    },
    getPageList(pageIndex) {
      const params = {
        organizationId: this.organizationId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      };
      if (this.textTit == "测评") {
        params.CourseType = 1;
      } else if (this.textTit == "活动") {
        params.CourseType = 3;
      } else {
        params.CourseType = 2;
      }
      this.tableRelevant.tableLoading = true;
      this.$http.CourseService.getCourseResources(params).then((res) => {
        this.tableRelevant.tableLoading = false;
        const { data, status, message } = res;
        this.tableRelevant.tableDataSource = data.items;
        this.tableRelevant.tablePagination.total = data.totalCount;
        this.tableRelevant.tablePagination.current = data.pageIndex;
      });
    },
    searchReset() {
      this.searchForm.courseName = "";
      this.searchForm.period = undefined;
      this.getPageList(1);
    },
    goCourseHourResource(item) {
      this.$store.commit("organization/setCourseHourResource", item);
      this.$router.push({
        path: `/projectImpl/pMechanism/orgDetails/courseHour`,
        query: {
          id: item.id,
          fullPath: window.encodeURIComponent(this.$route.fullPath),
          name: item.courseName,
          reportFrequency: item.reportFrequency,
        },
      });
    },
    addResource() {
      this.selectCourse.visible = true;
      this.handleType = "add";
    },
    async edit(json) {
      if (json.source == 1) {
        this.$message.warning("区域项目禁止修改");
        return;
      }
      this.$http.CourseResource.CourseReportsList({ CourseIds: json.courseResourceId }).then(res => {
        this.handleType = "edit";
        this.addCourseResourceDetailList = [
          {
            ...json,
            superiorCourseResourceId: json.superiorCourseResourceId,
            superiorOrganizationId: json.superiorOrganizationId,
            error: false,
            isLimitCount: !json.isLimitCount,
            maxCount: !json.isLimitCount ? undefined : json.maxCount,
            isLimitUsageTimes: !json.isLimitUsageTimes,
            usageTimes: !json.isLimitUsageTimes ? undefined : json.usageTimes,
            childCourseCount: json.childCourseCount,
            repeatErrMsg: "",
            reportFrequency: json.reportFrequency,
            reportChecked: json.courseReportIds,
            reportList: res.data,
            course: {
              courseChildCount: json.childCourseCount,
              maxChildCourseCount: json.maxChildCourseCount,
              id: json.id,
            },
          },
        ];
        this.addCourseResource.visible = true;
        console.log(this.addCourseResourceDetailList);
      });
    },
    //删除课程资源
    delCourseResource(val, index) {
      this.$message.destroy();
      if (val.source == 1) {
        this.$message.warning("区域项目禁止删除");
        return;
      }
      if (!val.id) {
        this.addCourseResourceDetailList.splice(index, 1);
        this.$message.success("删除成功");
        return;
      }
      if (val.usedCount != 0) {
        return this.$message.error("课程资源已被使用，无法删除！");
      }
      const that = this;
      this.$confirm({
        title: `确认要删除此${["", "测评", "训练", "活动"][val.courseType]}资源？`,
        content: "资源删除后所有相关数据都将删除且不可恢复，请谨慎操作",
        okType: "danger",
        centered: true,
        onOk() {
          const Params = {
            "id": val.id,
            "courseName": val.name,
            "period": val.period,
          }
          that.$http.CourseService.deleteCourseResources(Params).then((res) => {
            that.$message.success(res.message);
            that.getPageList(1);
          });
        },
      });
    },
    //选择课程确认
    selectCourseOk() {
      this.$message.destroy();
      const courseSelectedRow = this.$refs.addCourseResourceTable.$data.courseSelectedRowKeys.map((m) => JSON.parse(m));
      if (!courseSelectedRow.length) {
        this.$message.error("请选择课程");
        return;
      }

      const CourseIds = courseSelectedRow.map((v) => v.id);
      this.$http.CourseResource.CourseReportsList({ CourseIds }).then(({ data }) => {
        this.addCourseResourceDetailList = courseSelectedRow.map(v => {
          return {
            organizationCourseMaterialEnabled: true,
            course: v,
            courseName: v.name,
            id: v.id,
            maxCount: "",
            usageTimes: 1,
            courseId: v.id,
            period: v.period,
            error: false,
            errorTime: false,
            isLimitCount: false,
            isLimitUsageTimes: false,
            reportChecked: [],
            reportList: data.filter(f => f.courseId === v.id) || [],
            childCourseCount: undefined,
            courseChildCount: v.courseChildCount,
            repeatErrMsg: undefined,
            superiorCourseResourceId: v.superiorCourseResourceId,
            reportFrequency: undefined,
          };
        });
        console.log(this.addCourseResourceDetailList);
        this.selectCourse.visible = false;
        this.addCourseResource.visible = true;
      });
    },
    clearError(v, key) {
      if (key == "maxCount") {
        if (v.isLimitCount || v.maxCount || v.maxCount === 0) {
          v.error = false;
          v.boolerrMsg = null;
        } else {
          v.error = true;
          v.boolerrMsg = "请填写可用人次";
        }
      }
      const totalCourse = v.course.courseChildCount;
      if (this.$route.query.tabActive == 1 && key === "childCourseCount") {
        if (v.childCourseCount || v.childCourseCount === 0) {
          v.courseError = false;
          v.errMsg = null;
        } else {
          v.courseError = true;
          v.errMsg = "请填写课时数";
        }
        if (!v.courseError) {
          if (v.childCourseCount <= totalCourse) {
            v.courseError = false;
            v.errMsg = null;
          } else {
            v.courseError = true;
            v.errMsg = "课时数错误";
          }
        }
      }
    },
    async addPackCourse() {
      const PackResourceRef = this.$refs["PackResourceRef"];
      const packForm = await PackResourceRef.getForm();
      const user = JSON.parse(window.localStorage.getItem("USER_INFO"));
      const parmas = {
        addOrganizationCourseResourcePackageParams: [
          {
            name: packForm.name,
            courseType: { 测评: 1, 训练: 2, 活动: 3 }[this.textTit],
            organizationId: this.organizationId,
            maxCount: packForm.maxCount,
            isLimitCount: !packForm.isLimitCount,
            childCourseCount: packForm.childCourseCount,
            userId: user.id,
            userName: user.realName,
            courseConfigs: packForm.courseConfigs,
          },
        ],
      };
      this.addCourseResource.confirmLoading = true;
      const data = await this.$http.CourseService.addCoursePackage(parmas, { message: false })
        .catch((err) => {
          if (err.errors?.length) {
            const errCourse = this.coursePackList
              .filter((v) => err.errors.includes(v.id))
              .map((v) => v.courseName + "-" + v.period)
              .join("，");
            PackResourceRef.setErrorId(err.errors);
            this.$message.error(err.message + "：" + errCourse);
          } else {
            this.$message.error(err.message);
          }
          return err;
        })
        .finally(() => {
          this.addCourseResource.confirmLoading = false;
        });
      if (data.isSuccess) {
        this.$message.success("操作成功");
        this.addCourseResource.visible = false;
        this.selectCancel();
        this.addCourseResourceDetailList = [];
        this.getPageList(1);
        this.addCourseResourceCancel(true);
      }
    },
    //添加课程资源
    async addCourseResourceOk() {
      if (this.packResource) {
        return this.addPackCourse();
      }
      let bool = false;
      let boolTime = false;
      let courseErr = false;
      for (let i = 0; i < this.addCourseResourceDetailList.length; i++) {
        let v = this.addCourseResourceDetailList[i];
        v.courseError = false;
        v.errMsg = null;
        v.repeatError = false;
        v.repeatErrMsg = null;
        if (!v.isLimitCount && !v.maxCount && v.maxCount !== 0) {
          v.error = true;
          bool = true;
          v.boolerrMsg = "请填写可用人次";
        } else {
          v.error = false;
          this.$set(v, "error", false);
          bool = false;
          v.boolerrMsg = null;
        }
        if (!v.isLimitUsageTimes && !v.usageTimes) {
          v.errorTime = true;
          boolTime = true;
        } else {
          v.errorTime = false;
          boolTime = false;
        }
        const totalCourse = v.course.courseChildCount;
        if (this.$route.query.tabActive == 1) {
          if (!v.childCourseCount && v.childCourseCount !== 0) {
            v.courseError = true;
            courseErr = true;
            v.errMsg = "请填写课时数";
          }
          if (v.childCourseCount > totalCourse) {
            v.courseError = true;
            courseErr = true;
            v.errMsg = "课时数错误";
          }
        }
      }
      this.$message.destroy();
      if (bool) {
        this.$message.error("请设置可用人次");
        return;
      }
      if (boolTime) {
        this.$message.error("请设置使用次数");
        return;
      }
      if (courseErr) {
        return;
      }

      if (this.handleType !== "edit" && !(await this.checkCourseResource(this.addCourseResourceDetailList))) {
        return;
      }
      console.log(this.addCourseResourceDetailList);
      this.addCourseResource.confirmLoading = true;
      let Ajax = this.$http.CourseService.addCoursePackage;
      const Params = {
        superiorOrganizationId: this.addCourseResourceDetailList[0].superiorOrganizationId,
        addOrganizationCourseResourceParams: this.addCourseResourceDetailList.map(m => ({
          "id": this.handleType == "edit" ? m.id : undefined,
          "superiorOrganizationId": m.superiorOrganizationId,
          "maxUserCount": m.maxCount || 0,
          "isLimitUser": !m.isLimitCount,
          "source": m.source,
          "organizationId": this.organizationId,
          "superiorCourseResourceId": m.superiorCourseResourceId,
          "courseId": m.courseId || m.courseResourceId,
          "maxCount": m.maxCount || 0,
          "isLimitCount": !m.isLimitCount,
          "courseReportIds": m.reportChecked,
          "courseName": m.name || m.courseName,
          "period": m.period,
          "childCourseCount": m.childCourseCount,
          "reportFrequency": m.reportFrequency,
        })),
      };
      if (this.handleType == "edit") {
        Ajax = this.$http.CourseService.editCoursePackage;
        Params.editOrganizationCourseResourceParams = Params.addOrganizationCourseResourceParams;
        Params.addOrganizationCourseResourceParams = undefined;
      }
      Ajax(Params).then((res) => {
        this.$message.success("操作成功");
        this.addCourseResource.visible = false;
        this.selectCancel();
        this.addCourseResourceDetailList = [];
        this.getPageList(1);
        this.addCourseResourceCancel(true);
      }).finally(() => {
        this.addCourseResource.confirmLoading = false;
      });
    },
    addCourseResourceCancel(destory) {
      if (destory || this.handleType == "edit") {
        this.addCourseResourceDetailList = [];
        this.addCourseResForm.isLimitCount = false;
        this.addCourseResForm.isLimitUsageTimes = false;
        this.addCourseResForm.allCourse = false;
        this.addCourseResForm.childCourseCount = undefined;
        this.packResource = false;
        this.addCourseResource.visible = false;
        return;
      }
      this.selectCourse.visible = true;
      this.addCourseResource.visible = false;
      this.$nextTick(() => {
        this.selectIncludes.push(...this.addCourseResourceDetailList.map((v) => v.id));
        this.addCourseResourceDetailList = [];
        this.addCourseResForm.isLimitCount = false;
        this.addCourseResForm.isLimitUsageTimes = false;
        this.addCourseResForm.allCourse = false;
        this.addCourseResForm.childCourseCount = undefined;
        this.packResource = false;
      });
    },
    addCourseResFormSubmit(e) {
      e.preventDefault();
      this.addCourseResForm.form.validateFields((err, values) => {
        console.log(this.addCourseResForm);
        if (!err) {
          this.addCourseResourceDetailList = this.addCourseResourceDetailList.map((m) => {
            m.isLimitCount = this.addCourseResForm.isLimitCount;
            m.isLimitUsageTimes = this.addCourseResForm.isLimitUsageTimes;
            m.maxCount = m.configUserCount >= values.maxCount ? m.configUserCount || 0 : this.addCourseResForm.maxCount;
            m.usageTimes = values.usageTimes || 1;
            if (this.addCourseResForm.allCourse) {
              m.childCourseCount = m.course.courseChildCount;
              m.allCourse = true;
            } else {
              m.childCourseCount = this.addCourseResForm.childCourseCount;
              m.allCourse = false;
            }
            if (m.isLimitCount || m.maxCount || m.maxCount === 0) {
              this.clearError(m, "maxCount");
            }
            if (m.allCourse || m.childCourseCount || m.childCourseCount === 0) {
              this.clearError(m, "childCourseCount");
            }
            m.reportFrequency = this.addCourseResForm.reportFrequency;
            return m;
          });
        }
      });
    },
    addCourseResFormCheck(key) {
      this.$nextTick(() => {
        this.addCourseResForm.form.validateFields([key], { force: true });
      });
    },
    getContainer(bool, index) {
      if (bool) {
        this.$refs.liAction[index].style.display = "block";
      } else {
        setTimeout(() => (this.$refs.liAction[index].style.display = "none"), 230);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.err-msg {
  color: red;
  font-size: 12px;
}

.coutom-form-item {
  display: flex;
  flex-direction: column;
}

#CourseResource {
  padding: 24px 24px 24px 0;
  border: 1px solid #f0f0f0;

  .search,
  .operator {
    padding-left: 24px;
  }

  ul {
    padding: 24px;
    overflow: hidden;

    * {
      margin: 0;
      padding: 0;
    }

    li {
      // width: 375px;
      // height: 152px;
      // display: flex;
      // align-items: center;
      // box-shadow: 0 2px 16px 0 rgba(56, 57, 57, 0.17);
      // float: left;
      // padding: 15px;
      // margin-right: 30px;
      // margin-bottom: 30px;
      // border-radius: 7px;
      // position: relative;
      // overflow: hidden;
      // cursor: pointer;

      // img {
      //     width: 90px;
      //     height: 90px;
      //     object-fit: contain;
      //     margin-right: 20px;
      // }
      // h2 {
      //     font-size: 18px;
      //     font-weight: bold;
      //     color: #3d3d3d;
      //     line-height: 28px;
      //     margin-bottom: 15px;
      //     overflow: hidden;
      //     text-overflow: ellipsis;
      //     white-space: nowrap;
      // }
      // p {
      //     margin-bottom: 5px;
      // }
    }

    .resourcesItem {
      overflow: hidden;
      width: 440px;
      height: 275px;
      border-radius: 3px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      margin-right: 20px;
      margin-bottom: 20px;
      float: left;
      position: relative;
      line-height: 1;
      border: 1px solid #fff;
    }

    p,
    span,
    img {
      margin: 0;
      padding: 0;
    }

    .head {
      display: flex;
      height: 186px;
    }

    .h-left {
      flex-shrink: 0;
    }

    .h-right {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px 15px 0;
    }

    img {
      width: 186px;
      height: 186px;
      object-fit: cover;
    }

    .h-title {
      color: #fff;
      background-color: #4191f7;
      border-radius: 2px;
      padding: 3px 5px;
      font-size: 12px;
      position: absolute;
      left: 5px;
      top: 5px;
      opacity: 0.9;
    }

    .grey {
      font-size: 13px;
      background-color: #f7f7f7;
      border-radius: 5px;
      padding: 3px 6px;
      color: #575757;
      border: 1px solid #ebebeb;
      margin-right: 8px;
    }

    .blue {
      color: #4191f7;
      background-color: #e9f7fe;
      border: 1px solid #9fd4fb;
      border-radius: 5px;
      padding: 2px 5px;
      font-size: 12px;
      margin-right: 8px;
    }

    .h-right h4 {
      width: 92%;
      color: #000;
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .h-right svg {
      vertical-align: text-top;
    }

    .describe {
      padding: 5px;
      line-height: 23px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-top: 5px;

      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 45px;
      }

      .desc-content {
        margin-top: -46px;
      }
    }

    li:hover .action {
      display: block;
    }

    .action {
      float: right;
      display: none;
    }
  }
}

.addCourseResource {
  .head-form {
    display: flex;
    align-items: center;

    /deep/ .ant-form-inline .ant-form-item-with-help {
      margin-bottom: 0;
    }

    .ant-input-number {
      width: 120px;
      margin-right: 15px;
    }
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-right: 15px;
    flex-shrink: 0;
  }

  .content {
    width: 80%;
    margin: 0 auto;
    max-height: 500px;
    overflow-y: auto;
    box-sizing: border-box;
  }
}

.userCount /deep/ .ant-form-item-children {
  display: flex;
  align-items: center;
}

.err /deep/ .ant-select-selection {
  border-color: #f00;
}

.noShowLabel /deep/ label {
  opacity: 0;
}

.add-resource /deep/ .ant-modal {
  width: 60%;
  min-width: 1100px;
}

/deep/ .error-red {
  color: #f5222d;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.userCount /deep/ .ant-form-item-label label::before {
  content: '*';
  color: red;
  font-size: 18px;
  margin-right: 4px;
  position: absolute;
  left: -10px;
  top: -7px;
}

.tag {
  padding: 5px 5px !important;
  border: 1px solid #1890ff;
  border-radius: 5px;
  position: absolute;
  top: 7px;
  color: #1890ff;
}

.h-right .name {
  margin-left: 45px !important;
}

.jxzu {
  position: absolute;
  top: 10px;
  right: 100px;
  display: flex;
  align-items: center;
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  column-gap: calc((100% - 380px * 3) / 3);

  .item {
    margin-left: 20px;
  }
}

.pack-resource {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .pack-label {
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-right: 15px;
  }

  .pack-icon {
    font-size: 18px;
    margin-left: 12px;
  }

  .pack-tooltip {
    background: #999;
  }
}

.slide-fade-enter-active {
  transition: all 0.05s ease;
}

.slide-fade-leave-active {
  transition: all 0.05s;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
